import BaseModel from './base-model';
import Lesson from './lesson';

class Course extends BaseModel {
  constructor (data) {
    super(data);
    this.data = data;
  }

  set data (data) {
    super.data = data;

    this.scores = parseInt(data['scores']);
    this.authorId = parseInt(data['author_id']);
    this.teacherId = parseInt(data['teacher_id']);
    this.lessonsCounter = data['lessons_counter'];

    this.hidden = !!data['hidden'];
    this.backgroundRepeat = !!data['background_repeat'];
    this.officialCourse = !!data['official_course'];

    this.createdAt = data['created_at'];
    this.updatedAt = data['updated_at'];
    this.title = data['title'];
    this.description = data['description'];
    this.about = data['about'];

    this.image = data['image'];
    this.backgroundImage = data['background_image'];
    this.preview = data['preview'];
    this.partnerLogo = data['partner_logo'];

    this.author = data['author'];
    this.teacher = data['teacher'];

    this.lessons = [];

    if (data['lessons']) {
      this.lessons = data['lessons'].map(l => new Lesson(l));
    }
  }

  get data () {
    return {
      id: this.id,
      scores: this.scores,
      author_id: this.authorId,
      teacher_id: this.teacherId,
      lessons_counter: this.lessonsCounter,
      hidden: !!this.hidden,
      background_repeat: !!this.backgroundRepeat,
      official_course: !!this.officialCourse,
      title: this.title,
      description: this.description,
      about: this.about,
      image: this.image,
      background_image: this.backgroundImage,
      preview: this.preview,
      partner_logo: this.partnerLogo,
    };
  }
}

export default Course;
